import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { InputNumber, Select } from 'antd';
import OImageUpload from 'components/commons/OImageUpload';
import OTextField from 'components/commons/OTextField';
import ONumericInput from 'components/commons/ONumericInput';
import OCustomInput from 'components/commons/OCustomInput';
import OAgeComboInput from 'components/commons/OAgeComboInput';
import OAddressAutoComplete from 'components/commons/OAddressAutoComplete';
import { PersonaCrudService } from 'utils/PersonaCrudService';
import { translate } from 'react-i18next';
const Option = Select.Option;
class BasicInfo extends Component {

    constructor(props) {
        super(props);
        this.personaCrudService = new PersonaCrudService();
        this.state = {
            persona: props.persona,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ persona: nextProps.persona });
    }

    render() {
        const {t} = this.props;
        return (
            <Col md={12}>
                <Row>
                    <Col md={4}>
                        <OImageUpload container={this.state.persona} fieldName="avatar" onSave={this.updatePhoto.bind(this)}/>
                    </Col>
                    <Col md={8}>
                         <OTextField container={this.state.persona} fieldName="firstName" size="large" placeholder={t('assumption.basicInfo.firstName')} />
                         <OTextField container={this.state.persona} fieldName="lastName" size="large" placeholder={t('assumption.basicInfo.lastName')} />
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <OCustomInput container={this.state.persona} fieldName="age" label={t('assumption.basicInfo.age')} component={InputNumber} min={18} max={120}/>
                        <OCustomInput container={this.state.persona} fieldName="gender" label={t('assumption.basicInfo.gender.label')} component={Select} style={{width: "100%"}}>
                                  <Option value="MALE">{t('assumption.basicInfo.gender.items.male')}</Option>
                                  <Option value="FEMALE">{t('assumption.basicInfo.gender.items.female')}</Option>
                                  <Option value="OTHER">{t('assumption.basicInfo.gender.items.other')}</Option>
                                  <Option value="NA">{t('assumption.basicInfo.gender.items.na')}</Option>
                        </OCustomInput>
                        <OCustomInput container={this.state.persona} fieldName="info.maritalStatus" label={t('assumption.basicInfo.maritalStatus.items.single')} component={Select} style={{width: "100%"}}>
                                  <Option value="SINGLE">{t('assumption.basicInfo.maritalStatus.items.single')}</Option>
                                  <Option value="MARRIED">{t('assumption.basicInfo.maritalStatus.items.married')}</Option>
                                  <Option value="SEPARATED">{t('assumption.basicInfo.maritalStatus.items.separated')}</Option>
                                  <Option value="DIVORCED">{t('assumption.basicInfo.maritalStatus.items.divorced')}</Option>
                                  <Option value="WIDOWED">{t('assumption.basicInfo.maritalStatus.items.widowed')}</Option>
                                  <Option value="NA">{t('assumption.basicInfo.maritalStatus.items.na')}</Option>
                        </OCustomInput>
                        <OAgeComboInput container={this.state.persona} fieldName="info.children" label={t('assumption.basicInfo.children')} />
                        <OAddressAutoComplete container={this.state.persona} fieldName="info.location" label={t('assumption.basicInfo.location')} onUpdate={this.onUpdate.bind(this)} />
                    </Col>
                    <Col md={6}>
                        <OTextField container={this.state.persona} fieldName="info.quote" label={t('assumption.basicInfo.quote')} />
                        <OTextField container={this.state.persona} fieldName="info.jobTitle" label={t('assumption.basicInfo.jobTitle')}/>
                        <ONumericInput container={this.state.persona} fieldName="info.income" label={t('assumption.basicInfo.income')} prefix="$" />
                        <OTextField container={this.state.persona} fieldName="info.education" label={t('assumption.basicInfo.education')} />
                        <OTextField container={this.state.persona} fieldName="info.other" label={t('assumption.basicInfo.other')} />
                    </Col>
                </Row>
            </Col>
        );
    }

    onUpdate(persona) {
        if (this.props.onUpdate) {
            this.props.onUpdate(persona);
        }
        this.setState({ persona });
    }

    async updatePhoto(persona, canvas) {
        const result = await this.personaCrudService.updatePhoto(persona.id, canvas);
        if (result) {
            this.onUpdate(persona);
        }
        return result;
    }
}

export default translate('translations')(BasicInfo);


// WEBPACK FOOTER //
// ./src/components/assumptions/profiles/BasicInfo.js